// extracted by mini-css-extract-plugin
export var arrowIcon = "OutrightsList-module--arrowIcon--dde11";
export var blue = "#0eb3f2";
export var clamp = "OutrightsList-module--clamp--f663b";
export var clampSkeleton = "OutrightsList-module--clampSkeleton--bf100";
export var emphasis = "OutrightsList-module--emphasis--df1c3";
export var green = "#57d33b";
export var greenLink = "OutrightsList-module--green-link--7aebf";
export var grey = "var(--tone-mid)";
export var header = "OutrightsList-module--header--a8102";
export var headerSkeleton = "OutrightsList-module--headerSkeleton--3c343";
export var icon = "OutrightsList-module--icon--dce56";
export var iconSkeleton = "OutrightsList-module--iconSkeleton--2e693";
export var notchGap = "32px";
export var orange = "#f8662b";
export var outrightRow = "OutrightsList-module--outrightRow--ea886";
export var outrightRowSkeleton = "OutrightsList-module--outrightRowSkeleton--49b70";
export var outrightsList = "OutrightsList-module--outrightsList--5de0d";
export var pageContainer = "OutrightsList-module--pageContainer--f418e";
export var promoIcon = "OutrightsList-module--promoIcon--00b3b";
export var red = "#ff2741";
export var subtitle = "OutrightsList-module--subtitle--60c33";
export var subtitleSkeleton = "OutrightsList-module--subtitleSkeleton--41737";
export var title = "OutrightsList-module--title--91a14";
export var titleIcon = "OutrightsList-module--titleIcon--bd00c";
export var titleSkeleton = "OutrightsList-module--titleSkeleton--6e8fd";
export var widthDesktop = "1024px";
export var widthDesktopXl = "1280px";
export var widthExpanded = "1536px";
export var widthMobile = "640px";
export var widthTablet = "768px";
export var yellow = "#ffb100";